import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {selectRTL} from '../../selectors';

const Box = styled.span<{isRTL: boolean}>`
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${p => p.isRTL && 'text-align: right;'}
`;

const DirectionAuto = ({children}) => {
    const isRTL = useSelector(selectRTL);
    const dirProps = isRTL && {dir: 'auto', isRTL};
    return (
        <Box {...dirProps} data-testid="direction-auto">
            {children}
        </Box>
    );
};

export default DirectionAuto;
